import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDarkMode } from '../darkmode/DarkModeContext';

const Services = () => {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();

  const serviceList = [
    { icon: '/image/internet.png', name: 'Internet Rumah', desc: 'Fiber hingga 1 Gbps', link: '/produk' },
    { icon: '/image/internet_bisnis.png', name: 'Internet Bisnis', desc: 'Solusi enterprise', link: '/internet/dedicated' },
    { icon: '/image/IPTV.png', name: 'IPTV', desc: '200+ channel HD', link: '/tv-iptv' },
    { icon: '/image/starlink1.png', name: 'Starlink', desc: 'Data unlimited', link: '/produk-lainnya/starlink' },
    { icon: '/image/game.png', name: 'Gaming', desc: 'Low latency', link: '/gaming' },
    { icon: '/image/CCTV.png', name: 'CCTV', desc: 'IP Transit & CDN', link: '/cctv' },
    { icon: '/image/speedtest.png', name: 'Speed Test', desc: 'Tier 3 certified', link: '/speedtest' },
    { icon: '/image/custumer-service.png', name: 'Customer Service', desc: '24/7 monitoring', link: '/customer-service' }
  ];

  const fallbackIcons = ['🏠', '🏢', '📺', '📱', '🎮', '📹', '⚡', '🎧'];

  return (
    <div
      className="py-16 bg-cover bg-center"
      style={{
        backgroundImage: `url('https://telnet.net.id/assets/bg.png')`,
        backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
        backgroundBlendMode: 'overlay'
      }}
    >
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className={`text-3xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            Layanan Utama
          </h2>
          <p className={`max-w-2xl mx-auto text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Berbagai layanan internet terbaik untuk semua kebutuhan digital Anda.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {serviceList.map((service, index) => (
            <div
              key={index}
              onClick={() => navigate(service.link)}
              className={`card-base p-5 cursor-pointer flex flex-col items-center text-center ${
                isDarkMode
                  ? 'bg-gray-800 border border-gray-700 hover:border-[#1E9B4C]/40'
                  : 'bg-white border border-gray-100 hover:border-[#1E9B4C]/30'
              }`}
            >
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-3 ${
                isDarkMode
                  ? 'bg-gradient-to-br from-green-700 to-green-900'
                  : 'bg-gradient-to-br from-green-600 to-green-700'
              }`}>
                <img
                  src={service.icon}
                  alt={service.name}
                  className="w-12 h-12 object-contain filter brightness-0 invert"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const span = document.createElement('span');
                    span.className = 'text-xl';
                    span.textContent = fallbackIcons[index];
                    e.target.parentNode.appendChild(span);
                  }}
                />
              </div>
              <div className={`text-sm font-semibold mb-1 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                {service.name}
              </div>
              <div className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                {service.desc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
